import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const getLocations = rootStateBranchSelector('locations');
